exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-automation-node-start[data-v-7ca9839e]{width:300px}.fts-automation-node-start .node-header[data-v-7ca9839e]{position:relative}.fts-automation-node-start .node-header .node-header__debugpoint[data-v-7ca9839e]{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);right:1rem}.fts-automation-node-start .node-body .node-body__content[data-v-7ca9839e]{font-size:.875rem;text-align:center}", ""]);

// exports
